import { render } from "./form-input-groups.vue?vue&type=template&id=64152f4a"
import script from "./form-input-groups.vue?vue&type=script&lang=js"
export * from "./form-input-groups.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__